import React, { useMemo, useCallback, useEffect } from 'react';
import NotificationItem from '../../components/NotificationItem';
import { useNotifications } from '../../hooks/useNotifications';
import { logger } from '../../../../shared/utils/logger';
import './styles.css';
import { useTranslation } from 'react-i18next';

const NotificationsPage = () => {
  const { 
    notifications, 
    loading, 
    error, 
    hasMore, 
    loadMore,
    markAsRead
  } = useNotifications();
  const { t } = useTranslation('common');

  // Logger uniquement quand les données sont chargées
  useEffect(() => {
    if (!loading && notifications.length > 0) {
      logger.debug('NotificationsPage data loaded:', {
        count: notifications.length,
        notifications: notifications.map(n => ({
          id: n.id,
          type: n.type,
          read: n.read,
          createdAt: n.createdAt
        })).slice(0, 3)
      });
    }
  }, [notifications, loading]);

  const handleNotificationClick = useCallback((notification) => {
    if (!notification.read) {
      markAsRead(notification.id);
    }
  }, [markAsRead]);

  const renderNotifications = useMemo(() => {
    if (loading && notifications.length === 0) {
      return <div className="notifications-loading">Chargement...</div>;
    }

    if (error) {
      return <div className="notifications-error">{error}</div>;
    }

    return (
      <div className="notifications-list">
        {notifications.map(notification => (
          <div 
            key={notification.id} 
            onClick={() => handleNotificationClick(notification)}
          >
            <NotificationItem 
              notification={notification}
            />
          </div>
        ))}
        
        {hasMore && (
          <button 
            onClick={loadMore} 
            disabled={loading}
            className="load-more-button"
          >
            {loading ? t('actions.loading') : t('actions.loadMore')}
          </button>
        )}
      </div>
    );
  }, [notifications, loading, error, hasMore, loadMore, handleNotificationClick, t]);

  return (
    <div className="notifications-page">
      {renderNotifications}
    </div>
  );
};

export default React.memo(NotificationsPage); 